import React, { useState, useEffect, useRef } from 'react';

const AnimatedCard = ({ children, style, delay = 0, disableAnimation = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (disableAnimation) {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [disableAnimation]);

  return (
    <div
      ref={ref}
      className="widget-card"
      style={{
        ...style,
        opacity: disableAnimation ? 1 : (isVisible ? 1 : 0),
        animation: disableAnimation ? 'none' : (isVisible ? `pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${delay}s both` : 'none')
      }}
    >
      {children}
    </div>
  );
};

function Impressum({ darkMode }) {
  const textColor = darkMode ? '#e5e5e5' : '#4b4b4b';
  const headingColor = darkMode ? '#fff' : '#3c3c3c';

  const getCardStyle = (isHeader = false) => ({
    padding: isHeader ? '15px 20px' : '20px',
    backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
    border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
    borderRadius: '16px',
    boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
    marginBottom: '10px'
  });

  return (
    <main className="main-content" style={{ height: '100vh', overflowY: 'auto', paddingBottom: '40px' }}>
      <style>{`
        @keyframes pop-up {
          0% { transform: scale(0.95); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
      <div className="main-content-header" style={{ position: 'sticky', top: '20px', zIndex: 10, backgroundColor: '#1cb0f6', borderBottom: '4px solid #148ac2', borderRadius: '16px', color: 'white', marginBottom: '20px', marginTop: '20px' }}>
        <h2>Impressum</h2>
        <span>Rechtliche Informationen</span>
      </div>

      <div style={{ padding: '20px', maxWidth: '700px', margin: '0 auto', color: textColor }}>
        <AnimatedCard style={getCardStyle(true)} delay={0}>
            <h1 style={{ margin: 0, color: headingColor, fontSize: '1.5rem' }}>Impressum</h1>
        </AnimatedCard>

        <AnimatedCard style={getCardStyle()} delay={0.1}>
            <h2 style={{ color: headingColor, fontSize: '1.1rem', marginTop: 0 }}>Angaben gemäß § 5 TMG</h2>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', margin: 0 }}>
            </p>
        </AnimatedCard>

        <AnimatedCard style={getCardStyle()} delay={0.2}>
            <h2 style={{ color: headingColor, fontSize: '1.1rem', marginTop: 0 }}>Kontakt</h2>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', margin: 0 }}>
              E-Mail: info@duocode.fun
            </p>
        </AnimatedCard>

        <AnimatedCard style={getCardStyle()} delay={0.3}>
            <h2 style={{ color: headingColor, fontSize: '1.1rem', marginTop: 0 }}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', margin: 0 }}>
            </p>
        </AnimatedCard>

        <AnimatedCard style={getCardStyle()} delay={0.4}>
            <h2 style={{ color: headingColor, fontSize: '1.1rem', marginTop: 0 }}>Streitschlichtung</h2>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', margin: 0 }}>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={{color: '#1cb0f6'}}>https://ec.europa.eu/consumers/odr/</a>.<br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', marginTop: '8px', marginBottom: 0 }}>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
        </AnimatedCard>

        <AnimatedCard style={getCardStyle()} delay={0.5}>
            <h2 style={{ color: headingColor, fontSize: '1.1rem', marginTop: 0 }}>Haftungsausschluss</h2>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', margin: 0 }}>
              <strong>Haftung für Inhalte</strong><br />
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', marginTop: '8px', marginBottom: 0 }}>
              <strong>Haftung für Links</strong><br />
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
            <p style={{ fontSize: '0.9rem', lineHeight: '1.4', marginTop: '8px', marginBottom: 0 }}>
              <strong>Urheberrecht</strong><br />
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
        </AnimatedCard>
      </div>
    </main>
  );
}

export default Impressum;
